import {
  GET_DASHBOARD_QUEUE_TASKS,
  GET_DASHBOARD_QUEUE_TASKS_SUCCESS,
  GET_DASHBOARD_QUEUE_TASKS_ERROR,
} from './actionTypes';

const initialState = {
  errorGetDashboardQueueTasks: '',
  loadingGetDashboardQueueTasks: false,
  tasks: null,
  successGetDashboardQueueTasks: '',
};

const getDashboardQueueTasks = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_QUEUE_TASKS:
      state = { ...state, loadingGetDashboardQueueTasks: true };
      break;
    case GET_DASHBOARD_QUEUE_TASKS_SUCCESS:
      state = {
        ...state,
        loadingGetDashboardQueueTasks: false,
        tasks: action.payload.tasks,
        successGetDashboardQueueTasks: action.payload.message,
      };
      break;
    case GET_DASHBOARD_QUEUE_TASKS_ERROR:
      state = { ...state, errorGetDashboardQueueTasks: action.payload, loadingGetDashboardQueueTasks: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getDashboardQueueTasks;
